export const iconFontAwesomeHumanitarianLaptop = (
	<i className="fa-solid fa-laptop"></i>
);
